import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { FaUser, FaEnvelope, FaPhone, FaHeadset } from "react-icons/fa";

const Help = () => {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #ac2e62, #f7c1d9)",
      padding: "40px"
    }}>
      <Container className="d-flex justify-content-center">
        <Card style={{
          width: "100%",
          maxWidth: "500px",
          borderRadius: "15px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          padding: "20px"
        }}>
          
          {/* Header */}
          <div className="text-center mb-4">
            <FaHeadset size={40} color="#ac2e62" />
            <h2 style={{ marginTop: "10px", fontWeight: "bold" }}>
              Help & Support
            </h2>
            <p style={{ color: "gray" }}>
              We're here to help you anytime
            </p>
          </div>

          {/* Contact Card */}
          <Card style={{
            border: "none",
            background: "#f9f9f9",
            borderRadius: "10px",
            padding: "15px"
          }}>
            <h5 className="mb-3">Support Team</h5>

            <p>
              <FaUser color="#ac2e62" /> <strong> Name:</strong> Yash
            </p>

            <p>
              <FaEnvelope color="#ac2e62" /> <strong> Email:</strong> yash@tmgf.in
            </p>

            <p>
              <FaPhone color="#ac2e62" /> <strong> Phone:</strong> +91 97631 06074
            </p>
          </Card>

          {/* Buttons */}
          <div className="text-center mt-4">
            <Button
              variant="danger"
              style={{ marginRight: "10px", borderRadius: "20px" }}
              href="mailto:yash@tmgf.in"
            >
              Email Us
            </Button>

            <Button
              variant="success"
              style={{ borderRadius: "20px" }}
              href="tel:+919763106074"
            >
              Call Now
            </Button>
          </div>

        </Card>
      </Container>
    </div>
  );
};

export default Help;
